import { makeStyles } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useChatContentPageStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    height: "100dvh",
    width: "100%",
    overflow: "hidden",
    boxSizing: "border-box",
  },

  innerContainer: {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    width: "100%",
    height: "100dvh",
    overflow: "hidden",
    boxSizing: "border-box",
  },

  errorMessage: {
    color: designTokens.semantic.error,
    fontSize: "18px",
    fontWeight: 600,
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  chatWrapper: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    height: "100%",
    backgroundColor: designTokens.neutral[50],
    overflowX: "hidden",
    overflowY: "hidden",
  },

  temporaryChatWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
    height: "100%",
    flexShrink: 0,
    overflow: "hidden",
  },

  temporaryChatWrapperMobile: {
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100dvh",
    zIndex: 100,
    backgroundColor: designTokens.neutral[50],
    animationName: {
      from: { transform: "translateX(100%)" },
      to: { transform: "translateX(0)" },
    },
    animationDuration: "250ms",
    animationTimingFunction: "ease-out",
    animationFillMode: "forwards",
  },
});
